module.exports = __webpack_public_path__ + "img/GABY-SELE.ac23bdac.jpg";